const URL_PATTERN = /^https?:\/\//i;

export async function download(
  data: string | Blob | URL,
  fileName: string,
  mimeType = 'text/plain',
) {
  const isString = typeof data === 'string';
  let href;
  let isUrlBased = false;

  if (data instanceof URL || (isString && URL_PATTERN.test(data))) {
    href = data.toString();
    isUrlBased = true;
  } else if (isString) {
    href = `data:${mimeType};charset=utf-8,${encodeURIComponent(data)}`;
  } else if (data instanceof Blob) {
    href = URL.createObjectURL(data);
  } else {
    console.warn('Unsupported data type for download:', data);
    return;
  }

  const link = document.createElement('a');
  link.download = fileName;
  link.hidden = true;

  /*
    NOTE: the download attribute requires same-origin URLs: see [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/a#download)
    so attempt a download to convert to blob and open in a new tab/window as a backup
  */
  if (isUrlBased) {
    try {
      const res = await fetch(href);

      if (!res.ok) {
        throw new Error(
          `Failed to fetch file for download; fallback to opening in new tab/window. Status: ${res.status} ${res.statusText}`,
        );
      }

      const blob = await res.blob();
      href = URL.createObjectURL(blob);
    } catch (ex) {
      console.error('Error fetching file for download:', ex);
      link.target = '_blank';
    }
  }

  link.href = href;
  link.click();

  if (link.href?.startsWith('blob:')) {
    URL.revokeObjectURL(link.href);
  }
}
